import { Link } from 'react-router-dom';
import { type IComponentSchema } from '../../types';

interface IProps {
  schema: IComponentSchema<ILinkProps>;
}

export interface ILinkProps {
  text?: string;
  href?: string;
  target?: string;
  visible?: boolean;
  style?: React.CSSProperties;
}

const LinkComponent = ({ schema }: IProps) => {
  const { text, href, target, visible, style } = schema[
    'x-component-props'
  ] as ILinkProps;

  if (visible === false) return null;

  const rel = target === '_blank' ? 'noopener noreferrer' : undefined;

  // Internal paths ("/…", but not protocol-relative "//…") route client-side;
  // everything else (http(s)://, mailto:, tel:, #…) stays a plain <a>.
  const isInternal = !!href && href.startsWith('/') && !href.startsWith('//');

  if (isInternal) {
    return (
      <Link
        to={href as string}
        target={target || undefined}
        rel={rel}
        style={style}
        onClick={e => e.stopPropagation()}
      >
        {text}
      </Link>
    );
  }

  return (
    <a
      href={href || undefined}
      target={target || undefined}
      rel={rel}
      style={style}
      onClick={e => e.stopPropagation()}
    >
      {text}
    </a>
  );
};

export default LinkComponent;
